import { HealthState } from './HealthState';

export default HealthState;
